import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import { ReactComponent as TimelapseIcon } from '../../../assets/icons/timelapse_dark.svg';
import { ReactComponent as MedianIcon } from '../../../assets/icons/vertical_align_center.svg';
import { ReactComponent as GroupsIcon } from '../../../assets/icons/people_dark.svg';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: spacing(6),
    marginTop: spacing(8),
  },
  card: {
    boxSizing: 'border-box',
    borderRadius: 16,
    backgroundColor: primary.bluish8,
    padding: spacing(2, 4),
    display: 'flex',
    alignItems: 'center',
  },
  iconWrapper: {
    backgroundColor: primary.white,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginRight: spacing(4),
    width: 56,
    height: 56,
  },
  icon: {
    width: 24,
    height: 24,
  },
  content: {
    display: 'grid',
    rowGap: spacing(1),
  },
  value: {
    color: primary.black,
  },
  label: {
    color: primary.indigo,
  },
}));

const TimeToHireSummaryCards = ({ translations, summary }) => {
  const classes = useStyles();

  const cards = [
    {
      icon: TimelapseIcon,
      value: `${summary.average} ${translations.daysSuffix}`,
      label: translations.averageTimeToHireLabel,
    },
    {
      icon: MedianIcon,
      value: `${summary.median} ${translations.daysSuffix}`,
      label: translations.medianTimeToHireLabel,
    },
    {
      icon: GroupsIcon,
      value: `${summary.hires} ${translations.employeesSuffix}`,
      label: translations.totalHiresLabel,
    },
  ];

  return (
    <div className={classes.root}>
      {cards.map(({ icon: Icon, value, label }) => (
        <div key={label} className={classes.card}>
          <div className={classes.iconWrapper}>
            <Icon className={classes.icon} />
          </div>
          <div className={classes.content}>
            <Typography className={classes.value} variant="h3">
              {value}
            </Typography>
            <Typography className={classes.label} variant="subtitle2">
              {label}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
};

TimeToHireSummaryCards.propTypes = {
  translations: PropTypes.object.isRequired,
  summary: PropTypes.shape({
    average: PropTypes.number.isRequired,
    median: PropTypes.number.isRequired,
    hires: PropTypes.number.isRequired,
  }).isRequired,
};

export default TimeToHireSummaryCards;
